import { createSlice } from "@reduxjs/toolkit";

const usuarioSlice = createSlice({
    name: 'usuario',
    initialState: {
        usuario: [],
        permissaoDescItem: [],
        permissaoDescMov: [],
        permissaoDescCalculado: [],
        permissaoVenderNegativo: false
    },
    reducers: {
        addUsuario: (state, action) => {
            state.usuario = action.payload
        },
        addPermissaoDescItem: (state, action) => {
            state.permissaoDescItem = action.payload
        },
        addPermissaoDescMov: (state, action) => {
            state.permissaoDescMov = action.payload
        },
        addPermissaoDescCalculado: (state, action) => {
            state.permissaoDescCalculado = action.payload
        },
        addPermissaoVenderNegativo: (state, action) => {
            state.permissaoVenderNegativo = action.payload
        }
    }
});

export const { addUsuario, addPermissaoDescItem, addPermissaoDescMov, addPermissaoDescCalculado, addPermissaoVenderNegativo } = usuarioSlice.actions;
export default usuarioSlice.reducer;